/**
 * Tree of life spanning the boundary between two sections.
 *
 * The SVG is used as a CSS mask so it can be tinted with brand colors.
 * Each section renders its own copy, anchored to the shared edge so the
 * trunk base (ground line) sits exactly on the boundary:
 *  - `top`    → canopy, placed at the bottom of the section above
 *  - `bottom` → roots, placed at the top of the section below
 * The parent section must be `relative overflow-hidden` to clip its part.
 */

// Tree height — large on desktop, width-bound on mobile.
const TREE_HEIGHT = 'min(150svh, 220vw)';
// Ground line position within the SVG viewBox (fraction of its height).
const GROUND_RATIO = 0.66;

type TreeOfLifeProps = {
  part: 'top' | 'bottom';
  className?: string;
};

export default function TreeOfLife({ part, className = '' }: TreeOfLifeProps) {
  const offset =
    part === 'top'
      ? { bottom: `calc(${TREE_HEIGHT} * -${(1 - GROUND_RATIO).toFixed(2)})` }
      : { top: `calc(${TREE_HEIGHT} * -${GROUND_RATIO})` };

  return (
    <div
      aria-hidden="true"
      className={`absolute left-1/2 -translate-x-1/2 pointer-events-none ${className}`}
      style={{
        ...offset,
        height: TREE_HEIGHT,
        aspectRatio: '580 / 386',
        maskImage: 'url(/Tree-of-life-580x386.svg)',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        maskSize: 'contain',
        WebkitMaskImage: 'url(/Tree-of-life-580x386.svg)',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize: 'contain',
      }}
    />
  );
}
